import axios from "axios";


async function createSupportRequest(supportRequest_id, data) {
    return await new Promise((resolve, reject) => {
        try {
            let url = `/api/supports/`;
            if (supportRequest_id) url += supportRequest_id
            axios.post(url, data).then(async res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            });
        } catch (err) {
            reject(err);
        }
    })
}

export {
    createSupportRequest
}